
  <sm-title-bar [headerCustomTemplate]="addButton" pageTitle="Service Templates">
    <ng-template #addButton>
      <button mat-button color="accent" (click)="onCreateNewService()">
        
        <mat-icon class="material-icons-round try" [inline]="true">add_circle</mat-icon>
        
      </button>
    </ng-template>
  </sm-title-bar>
<mat-card appearance="outlined" *ngIf="!loader">
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
      
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="serviceList" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         [showPagination]="true" [showImageColumn]="true"  [imageTemplate]="image" [itemsPerPage]="5">
      </sm-data-table>
    </div>
  </mat-card>

  <div *ngIf="loader" class="loader">
    <mat-spinner></mat-spinner>
  </div>

  <ng-template #menuTemplate let-rowvalue>
    
    <button mat-menu-item (click)="onEdit(rowvalue)">
      <mat-icon class="material-icons-outlined">menu</mat-icon>
      <span>Edit</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.status == 1" (click)="deactivateService(rowvalue)">
      <mat-icon class="material-icons-outlined">person_add_disabled</mat-icon>
      <span>Deactivate</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.status == 7" (click)="activateService(rowvalue)">
      <mat-icon class="material-icons-outlined">person_add_disabled</mat-icon>
      <span>Activate</span>
    </button>
    <button mat-menu-item (click)="deleteService(rowvalue)">
        <mat-icon class="material-icons-outlined">person_add</mat-icon>
        <span>Delete</span>
      </button>
  </ng-template>

  <ng-template #image let-objValue>
    <img
      [src]="
        objValue['imgUrl'] !== null && objValue['imgUrl'] !== 'null'
          ? objValue['imgUrl']
          : './assets/images/photo.png'
      "
      class="img-fluid rounded-circle"
    />
  </ng-template>
<!-- <mat-paginator
  class="mt-4"
  [length]="totalData"
  [pageSize]="8"
  (page)="onPageChange($event)"
>
</mat-paginator> -->

